import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  notificationFail,
  notificationSuccess,
} from "../slices/notificationSlice";
import { locationList, setLoader } from "../slices/locationSlice";
import {
  addNewInternalLoader,
  internalIdList,
  setDeviceIdLinkWithInternalIdLoader,
  setInternalLoader,
} from "../slices/inernalIdsSlice";
import { csvImportCount } from "../slices/locationCsvUploadRespoSlice";
import {
  createNewTenantMutation,
  addLocationWithCsvMutation,
  setLocation,
  addInternalIdsMutation,
  internalIdLinkMutation,
  internalIdUnlinkMutation,
  DeviceIdLinkWithInternalIdMutation,
  updateLocationOrderMutation,
  storeFacility3DSpaceIdMutation,
  store3DFacilityDeviceLocationMutation,
} from "../../graphql/mutations";
import {
  getLocationListQuery,
  getInternalIdsQuery,
  getFacilityDeviceLocationsQuery,
} from "../../graphql/queries";

import { API, graphqlOperation, Auth } from "aws-amplify";
import { ChangeServiceRequest } from "./commonThunk";
import { devApi, prodApi, qaApi } from "../../aws-export";
import { setLoader as setAuthLoader } from "../slices/authSlice";
import { setLoaderMeasurement } from "../slices/substanceSlice";
type LocationOrderRequestType = {
  key: String;
  orderNumber?: Number;
  unit_room_order?: number;
  facility_unit_room_order?: number;
  tenantId: String;
  type: String; // STM,FCL,FLR,UNI,LOC
};
export const getLocationLists = createAsyncThunk(
  "tenantList",
  async (_request: any, { dispatch }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    try {
      dispatch(setLoaderMeasurement(true));
      dispatch(setLoader(true));
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );

      const username = await Auth.currentAuthenticatedUser()
        .then(async (user: any) => {
          return user.username;
        })
        .catch((err) => {
          return null;
        });

      const userList = (await API.graphql({
        ...graphqlOperation(getLocationListQuery, {
          tenantCode: _request.tenantId,
          username: username,
          is_deleted: _request.is_deleted,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };

      dispatch(locationList(userList.data));
      if (userList?.data?.getLocations?.length === 0) {
        dispatch(setLoaderMeasurement(false));
      }
      if (_request?.setLocations) {
        _request?.setLocations(userList?.data?.getLocations);
      }
      dispatch(setLoader(false));
      return userList?.data?.getLocations || []
    } catch (err: any) {
      dispatch(setLoader(false));
      dispatch(setLoaderMeasurement(false));
      return []
    }
  }
);

export const addNewLocation = createAsyncThunk(
  "addNewLocation",
  async (_request: any, { dispatch }) => {
    dispatch(setLoader(true));

    try {
      const data = (await API.graphql({
        ...graphqlOperation(createNewTenantMutation, {
          location: _request.request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };

      if (data.data.createLocation.success === "true") {
        let request = {
          tenantId: _request.request.tenantId,
          is_deleted: false,
          setLocations: _request.setLocations,
        };
        dispatch(getLocationLists(request));
        if (_request.request.type === "S") {
          dispatch(
            notificationSuccess(
              _request.request.key
                ? "System Updated Successfully"
                : "System Created Successfully"
            )
          );
        } else if (_request.request.type === "F") {
          dispatch(
            notificationSuccess(
              _request.request.key
                ? "Facility Updated Successfully"
                : "Facility Created Successfully"
            )
          );
        } else if (_request.request.type === "L") {
          dispatch(
            notificationSuccess(
              _request.request.key
                ? "Floor Updated Successfully"
                : "Floor Created Successfully"
            )
          );
        } else if (_request.request.type === "U") {
          dispatch(
            notificationSuccess(
              _request.request.key
                ? "Department Updated Successfully"
                : "Department Created Successfully"
            )
          );
        } else if (_request.request.type === "R") {
          dispatch(
            notificationSuccess(
              _request.request.key
                ? "Room Updated Successfully"
                : "Room Created Successfully"
            )
          );
        }
        dispatch(setLoader(false));
      } else {
        dispatch(notificationFail("Something went wrong"));
      }
      if (_request.callback) {
        _request.callback();
      }
    } catch (err: any) {
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const uploadNewCsv = createAsyncThunk(
  "addNewLocation",
  async (_request: any, { dispatch }) => {
    dispatch(setLoader(true));

    try {
      const addNewUser = (await API.graphql({
        ...graphqlOperation(addLocationWithCsvMutation, {
          csvData: _request.request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };

      if (
        addNewUser.data.addLocationWithCsv.deviceUploaded > 0 ||
        addNewUser.data.addLocationWithCsv.roomUploaded > 0 ||
        addNewUser.data.addLocationWithCsv.deviceNotUploaded > 0 ||
        addNewUser.data.addLocationWithCsv.emptyRoom > 0
      ) {
        dispatch(notificationSuccess("CSV file Import Successfully"));
        dispatch(
          SetImportCsvResponse({ request: addNewUser.data.addLocationWithCsv })
        );
      } else {
        dispatch(
          notificationFail(
            "Opps! CSV file is not import. Please add data in csv file"
          )
        );
      }

      dispatch(setLoader(false));
      if (_request.callback) {
        _request.callback();
      }
    } catch (err: any) { }
  }
);

export const setDefaultLocation = createAsyncThunk(
  "setDefaultLocation",
  async (_request: any, { dispatch }) => {
    dispatch(setLoader(true));
    try {
      const setDeLocation = await API.graphql({
        ...graphqlOperation(setLocation, { defaultLocation: _request.request }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      });
      dispatch(
        notificationSuccess("Set Default Location  Updated Successfully ")
      );
      dispatch(setLoader(false));
    } catch (err: any) {
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const SetImportCsvResponse = createAsyncThunk(
  "SetImportCsvResponse",
  async (_request: any, { dispatch }) => {
    dispatch(csvImportCount(_request.request));
  }
);

export const addInternalIds = createAsyncThunk(
  "addInternalIds",
  async (_request: any, { dispatch }) => {
    dispatch(addNewInternalLoader(true));
    try {
      const InternalIdsResponse = (await API.graphql({
        ...graphqlOperation(addInternalIdsMutation, {
          internalIds: { internalIds: _request.request },
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };
      if (InternalIdsResponse.data.createInternalDeviceIds.success == "true") {
        dispatch(notificationSuccess("Inernal Ids Added"));
      } else {
        dispatch(notificationSuccess("Inernal Ids not Add"));
      }
      dispatch(addNewInternalLoader(false));
    } catch (err: any) {
      dispatch(notificationFail("Something went wrong"));
      dispatch(addNewInternalLoader(false));
    }
  }
);
export const internalIdLinkWithTenantThunk = createAsyncThunk(
  "internalIdLink",
  async (_request: any, { dispatch }) => {
    dispatch(setInternalLoader(true));
    try {
      const response = (await API.graphql({
        ...graphqlOperation(internalIdLinkMutation, {
          internallink: _request.request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };
      if (response.data.internalDeviceIdLinkWithTenant.success == "true") {
        dispatch(notificationSuccess("Internal Id Linked"));
      } else {
        dispatch(notificationSuccess("Internal Id Not Linked"));
      }
      dispatch(setInternalLoader(false));
    } catch (err: any) {
      dispatch(setInternalLoader(false));
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const internalIdUnlinkWithTenantThunk = createAsyncThunk(
  "internalIdUnlink",
  async (_request: any, { dispatch }) => {
    dispatch(setInternalLoader(true));
    try {
      const response = (await API.graphql({
        ...graphqlOperation(internalIdUnlinkMutation, {
          internalunlink: _request.request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };
      if (response.data.internalDeviceIdUnLinkWithTenant.success == "true") {
        // dispatch(notificationSuccess("Internal Id Unlink"));
        dispatch(
          notificationSuccess(
            response.data.internalDeviceIdUnLinkWithTenant.message
          )
        );
      } else {
        // dispatch(notificationFail("Internal Id Not Unlink"));
        dispatch(
          notificationFail(
            response.data.internalDeviceIdUnLinkWithTenant.message
          )
        );
      }

      dispatch(setInternalLoader(false));
      // dispatch(getInernalIds({}))
    } catch (err: any) {
      dispatch(setInternalLoader(false));
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const getInernalIds = createAsyncThunk(
  "getInernalIds",
  async (_request: any, { dispatch }) => {
    dispatch(setInternalLoader(false));
    try {
      const response = (await API.graphql({
        ...graphqlOperation(getInternalIdsQuery, _request),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };
      dispatch(internalIdList(response.data.getAllInternalDeviceIds));
      dispatch(setInternalLoader(false));
    } catch (err: any) {
      dispatch(setInternalLoader(false));
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const DeviceIdLinkWithInternalIdThunk = createAsyncThunk(
  "deviceIdLinkWithInternalId",
  async (_request: any, { dispatch }) => {
    dispatch(setDeviceIdLinkWithInternalIdLoader(true));
    try {
      const response = (await API.graphql({
        ...graphqlOperation(DeviceIdLinkWithInternalIdMutation, {
          deviceinternalidlink: _request.request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };
      if (response.data.deviceLinkWithInternalId.success == "true") {
        dispatch(
          notificationSuccess(response.data.deviceLinkWithInternalId.message)
        );
      } else {
        dispatch(
          notificationFail(response.data.deviceLinkWithInternalId.message)
        );
      }
      dispatch(setDeviceIdLinkWithInternalIdLoader(false));
      // dispatch(getInernalIds({}))
      if (
        _request.callback &&
        response.data.deviceLinkWithInternalId.success == "true"
      ) {
        _request.callback();
      }
    } catch (err: any) {
      dispatch(setDeviceIdLinkWithInternalIdLoader(false));
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const updateLocationOrder = createAsyncThunk(
  "updateLocationOrder",
  async (
    {
      _request,
      revertOrderUpdate,
    }: { _request: LocationOrderRequestType[]; revertOrderUpdate: () => void },
    { dispatch }
  ) => {
    dispatch(setLoader(true));
    try {
      const data = (await API.graphql({
        ...graphqlOperation(updateLocationOrderMutation, {
          locationOrder: { orderData: JSON.stringify(_request) },
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };
      if (data?.data?.updateLocationOrder?.success === "true") {
        dispatch(notificationSuccess("Order Updated Successfully"));
      } else {
        dispatch(notificationFail("Order is not updated. please tru again."));
        revertOrderUpdate();
      }
    } catch (err) {
      console.log(err);
      revertOrderUpdate();
      dispatch(notificationFail("Order is not updated. please tru again."));
    } finally {
      dispatch(setLoader(false));
    }
  }
);

export const storeFacility3DSpaceId = createAsyncThunk(
  "storeFacility3DSpaceId",
  async (
    _request: { facilityKey: string; tenantCode: string; spaceId: string },
    { dispatch }
  ) => {
    try {
      const response = (await API.graphql({
        ...graphqlOperation(storeFacility3DSpaceIdMutation, {
          storeSpaceId: _request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; errors: any[] };
      const data = response?.data?.storeFacility3DSpaceIdM;
      if (data?.success === "true") {
        dispatch(notificationSuccess("3D space id is stored successfully."));
        dispatch(getLocationLists({ tenantId: _request?.tenantCode }));
      } else {
        dispatch(notificationFail("3D space id is not stored."));
      }
    } catch (e) {
      console.log(e);
      dispatch(notificationFail("3D space id is not stored."));
    }
  }
);

export const store3DFacilityDeviceLocation = createAsyncThunk(
  "store3DFacilityDeviceLocations",
  async (
    _request: {
      facilityKey: string;
      tenantCode: string;
      deviceLocation: string;
    },
    { dispatch }
  ) => {
    try {
      const response = (await API.graphql({
        query: store3DFacilityDeviceLocationMutation,
        variables: {
          storeDeviceLocation: _request,
        },
      })) as { data: any; errors: any[] };
      const data = response?.data?.store3DFacilityDeviceLocations;
      if (data?.success === "true") {
        dispatch(
          notificationSuccess("Facility device location stored successfully.")
        );
      } else {
        dispatch(notificationFail("Facility device location not stored."));
      }
    } catch (err) {
      console.log(err);
      dispatch(notificationFail("3D space id is not stored."));
    }
  }
);

export const getFacilityDeviceLocations = createAsyncThunk(
  "getFacilityDeviceLocations",
  async (
    _request: { tenantCode: string; facilityKey: string },
    { dispatch }
  ) => {
    try {
      // dispatch(setAuthLoader(true));
      const loginwithtype = localStorage.getItem("loginwith") || "";
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );
      const response = (await API.graphql({
        query: getFacilityDeviceLocationsQuery,
        variables: {
          facilityDeviceLocation: _request,
        },
      })) as { data: any; errors: any[] };
      // dispatch(setAuthLoader(false));
      const data = response?.data?.getFacilityDeviceLocationsQ?.data || "[]";
      return JSON.parse(data);
    } catch (err) {
      // dispatch(setAuthLoader(false));
      console.log(err);
      return [];
    }
  }
);
